<div id="codeListCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@codeList_title">Codici d'attivazione</ng-container>
    <fa-icon *ngIf="canUserEdit" icon="edit" class="float-right margin-right-20 icon-clickable"
      (click)="modifyCodeList()"></fa-icon>
  </div>

  <div class="control-card-content">

    <div class="table-container">

      <table mat-table matSort #codelisttable [dataSource]="dataSource" class="simple-table">

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef i18n="@@codeList_code" style="width: 12%;">Codice</th>
          <td mat-cell *matCellDef="let element"> {{ element.code }} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef i18n="@@codeList_description" style="width: 36%;">Descrizione</th>
          <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef i18n="@@codeList_date" style="width: 15%;">Data d'attivazione</th>

          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.activatedAt">
              {{formatDate(element.activatedAt)}}
            </ng-container>
            <ng-container *ngIf="!element.activatedAt" i18n="@@codeList_not_activated">
              Non attivato
            </ng-container>

          </td>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef i18n="@@codeList_welcome_email" style="width: 15%;">Email benvenuto
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.activationEmail }} </td>

            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.activationEmail">
                {{element.activationEmail}}
              </ng-container>
              <ng-container *ngIf="!element.activationEmail" i18n="@@codeList_not_assigned">
                Non assegnata
              </ng-container>
          </ng-container>


          <ng-container matColumnDef="emailDate">
            <th mat-header-cell *matHeaderCellDef i18n="@@codeList_email_date" style="width: 17%;">Data invio</th>

            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.activationEmailSentDate">
                {{formatDate(element.activationEmailSentDate)}}
              </ng-container>
              <ng-container *ngIf="!element.activationEmailSentDate" i18n="@@codeList_not_sent">
                Non inviata
              </ng-container>
          </ng-container>


          <ng-container matColumnDef="sendButton">
            <th mat-header-cell *matHeaderCellDef style="width: 5%;"> </th>
            <td mat-cell *matCellDef="let element">
              <fa-icon *ngIf="canUserEdit" icon="share-square" class="float-right padding-5 icon-clickable"
                (click)="getOwnerDefaultEmail(element)"></fa-icon>
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>

      </table>

    </div>

  </div>

  <app-loading-screen #codelistloader></app-loading-screen>

</div>